(function (angular) {
  "use strict";

  var controllerId = "resetPasswordController";
  angular
    .module("app")
    .controller(controllerId, ["$scope", "$location", "$timeout", "Messages", "alkAuthenticationService", "ALKResetPassword", function ($scope, $location, $timeout, Messages, alkAuthenticationService, ALKResetPassword) {
      var redirectTo = $location.search().r;

      $scope.submitResetPassword = function () {
        $scope.isProcessing = true;
        Messages.clear();

        var resetPassword = new ALKResetPassword($scope.userInfo.email, $scope.userInfo.password, $scope.userInfo.token);
        alkAuthenticationService.resetPassword(resetPassword)
          .then(function () {
            Messages.add("success", "Password has been reset.", {
              showOnNextPage: true
            });

            if (redirectTo === "signup") {
              $location.url("/signup?userName=" + $scope.userInfo.email);
            } else {
              $location.url("/login");
            }

          }, function (err) {
            if (err && err.data && err.data.Message) {
              Messages.add("danger", err.data.Message, {
                showOnNextPage: false
              });
            } else {
              Messages.add("danger", "Error while resetting password.", {
                showOnNextPage: false
              });
            }
          }).finally(function () {
            $scope.isProcessing = false;
          });
      };

      $scope.init = function () {
        var searchObject = $location.search();
        $scope.tokenExists = searchObject.token ? true : false;
        $scope.showTokenField = !$scope.tokenExists;
        $scope.userInfo = {
          email: searchObject.email,
          token: searchObject.token
        };

        // initialize the correct field on page load
        if ($scope.userInfo.email && $scope.userInfo.token) {
          $timeout(function () {
            $("#password").focus(); // jshint ignore:line
          });
        } else if ($scope.userInfo.email) {
          $timeout(function () {
            $("#token").focus(); // jshint ignore:line
          });
        } else {
          $timeout(function () {
            $("#email").focus(); // jshint ignore:line
          });
        }
      };
    }]);
})(window.angular);



// WEBPACK FOOTER //
// ./app/account/resetPassword.controller.js